import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import React, { Suspense } from 'react';
import { isMobile } from 'react-device-detect';
import { Loading, Application as AppEnum } from '@fides/fides-react-components';
import { redirectToExternalURL } from 'core/helpers';
import { useGlobalConfigContext } from '../contexts/GlobalConfig';
import { externalUrls } from '../consts';

const LoginPage = React.lazy(() => import('../../components/pages/Login'));

export const Login = () => {
  const { user, userIsLoggedIn, getAppUrl, hasUserAppAccess } = useGlobalConfigContext();
  const history = useHistory();

  if (userIsLoggedIn && isMobile && hasUserAppAccess(AppEnum.EFTWEB)) {
    redirectToExternalURL(`${getAppUrl(AppEnum.EFTWEB)}${externalUrls.eftMobileOrderOverview}`);
  }

  if (userIsLoggedIn && (user?.isPartnerEndUser || user?.isCorporateEndUser)) {
    history.push('/DLC/overview');
  }

  return (
    <Switch>
      {userIsLoggedIn && !user?.isPartnerEndUser && !user?.isCorporateEndUser ? (
        <Redirect to='/dashboard' />
      ) : (
        <Route
          path='/login'
          render={() => (
            <Suspense fallback={<Loading />}>
              <LoginPage />
            </Suspense>
          )}
        />
      )}
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
